/* 
    Main page for the charger table view for comparing land parcels.
*/

import React from 'react';
import ParcelComparisonTable from '../../components/charger_planning/ParcelComparisonTable';
import { useParcels } from '../../contexts/ParcelContext';
import { exportParcelsToPDF } from '../../utils/parcelPdfExport';
import { exportParcelsToExcel } from '../../utils/parcelExcelExport';
import { FaFilePdf, FaFileExcel } from 'react-icons/fa';

function ChargerTableView() {
    const { selectedParcels } = useParcels();

    const handleExportPDF = () => {
        if (selectedParcels.length === 0) {
            alert('Please select parcels to export');
            return;
        }
        exportParcelsToPDF(selectedParcels);
    };

    const handleExportExcel = () => {
        if (selectedParcels.length === 0) {
            alert('Please select parcels to export');
            return;
        }
        exportParcelsToExcel(selectedParcels);
    };

    return (
            <main className="bg-gray-50 font-ui min-h-[125vh]">
                <div className="p-4 sm:p-6 lg:p-8 max-w-7xl mx-auto">
                    {/* Export Buttons */}
                    {selectedParcels.length > 0 && (
                        <div className="mb-4 flex justify-end gap-3">
                            <button
                                onClick={handleExportExcel}
                                className="inline-flex items-center px-4 py-2 bg-green-600 text-white font-medium rounded-md hover:bg-green-700 transition-colors shadow-sm"
                            >
                                <FaFileExcel className="mr-2" />
                                Export to Excel
                            </button>
                            <button
                                onClick={handleExportPDF}
                                className="inline-flex items-center px-4 py-2 bg-blue-600 text-white font-medium rounded-md hover:bg-blue-700 transition-colors shadow-sm"
                            >
                                <FaFilePdf className="mr-2" />
                                Export to PDF
                            </button>
                        </div>
                    )}
                    <ParcelComparisonTable />
                </div>
            </main>
    );
}

export default ChargerTableView;